import * as Theme from './theme';
import { iniciarProtecaoDeEnvio } from '@helpers/envio';
import { iniciarConfirmacoes } from '@helpers/confirmacao';
import { iniciarOlhosDeSenha } from '@helpers/senha';
import { iniciarCamposDependentes } from '@helpers/dependencia';
import { iniciarMascaras } from '@helpers/mascara';
import { iniciarSelecoesMultiplas, iniciarSelecoesRemotas } from '@helpers/selecao';
import { iniciarBuscaDeCep } from '@helpers/cep';
import { iniciarAbas } from '@helpers/abas';

document.addEventListener('DOMContentLoaded', () => {
    Theme.init();
    iniciarConfirmacoes();
    iniciarProtecaoDeEnvio();
    iniciarOlhosDeSenha();
    iniciarCamposDependentes();
    iniciarMascaras();
    iniciarSelecoesMultiplas();
    iniciarSelecoesRemotas();
    // Depois das selecoes: a busca de CEP escreve no campo de municipio, que
    // precisa ja ser um tom-select quando isso acontecer.
    iniciarBuscaDeCep();
    // Depois de tudo: ela procura erro de validacao ja renderizado, e o erro
    // vindo do servidor esta no HTML desde o inicio.
    iniciarAbas();

    const elementosComTooltip = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    elementosComTooltip.forEach(elemento => {
        new (window as any).bootstrap.Tooltip(elemento);
    });
});
